export default __webpack_public_path__ + "static/media/acadot100.9955ee81.png";